<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <public-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-lg mx-auto" v-if="type === 'SMS'">
                <h3 class="font-bold text-2xl mb-8">{{ $t("enterAuthCode") }}</h3>
                <p class="mb-3">
                    {{ $t("authCodeSent", [mobilePhone]) }}
                </p>
                <form autocomplete="off">
                    <k-input
                            class="mb-4"
                            id="code"
                            label="Code"
                            v-model="form.code"
                            :field-errors="validation.fieldErrors"/>
                    <div class="mt-6 w-auto flex block">
                        <div class="flex-grow">
                            <k-button @click.native.prevent="onSubmit">
                                {{ $t("authenticate") }}
                            </k-button>
                        </div>
                        <div>
                            <a-button type="link" @click="sendCode" class="px-0 text-sm">
                                {{ $t("resendCode") }}
                            </a-button>
                        </div>
                    </div>
                </form>
                <div class="mt-5 text-gray-500 text-sm" v-if="authenticationCode">
                    {{authenticationCode}}
                </div>
            </div>
            <div class="max-w-lg mx-auto" v-if="type === 'TOTP'">
                <h3 class="font-bold text-2xl mb-8">Enter one time password</h3>
                <p class="mb-3">
                    Please check your authenticator app for current one time password.
                </p>
                <form autocomplete="off">
                    <k-input
                        class="mb-4"
                        id="code"
                        label="Code"
                        v-model="form.code"
                        :field-errors="validation.fieldErrors"/>
                    <div class="mt-6 w-auto flex block">
                        <div class="flex-grow">
                            <k-button @click.native.prevent="onSubmit">
                                {{ $t("authenticate") }}
                            </k-button>
                        </div>
                    </div>
                </form>
                <div class="mt-5 text-gray-500 text-sm" v-if="authenticationCode">
                    {{authenticationCode}}
                </div>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import PublicHeader from '@investor/components/PublicHeader'

export default {
        components: {
            PublicHeader
        },
        data() {
            return {
                loading: false,
                type: null,
                form: {
                    code: ""
                },
                authenticationCode: "",
                mobilePhone: "",
                validation: {
                    fieldErrors: {}
                }
            }
        },
        async mounted() {
            if (this.$authToken()) {
                await this.$fetchInvestorProfile();
                await this.$routeInvestor();
            } else {
                await this.init();
            }
        },
        methods: {
            async init() {
                try {
                    const resp = await this.$get('2fa/init')
                    // for testing only, on production will be empty
                    this.authenticationCode = resp.authenticationCode;
                    this.mobilePhone = resp.mobilePhone;
                    this.type = resp.type;
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        await this.$router.push('/');
                    }
                }
            },
            async sendCode() {
                try {
                    const resp = await this.$post('2fa/send-code')
                    // for testing only, on production will be empty
                    this.authenticationCode = resp.authenticationCode;
                    this.mobilePhone = resp.mobilePhone;
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        await this.$router.push('/');
                    }
                }
            },
            async onSubmit() {
                this.validation = {
                    fieldErrors: {}
                };
                try {
                    const resp = await this.$post('2fa/authenticate', this.form);
                    await this.$login(resp.token);
                } catch (error) {
                    console.error(error)
                    if (error.response && error.response.status === 400) {
                        this.validation = error.response.data;
                        this.$scrollToErrorField();
                    } else if (error.response && error.response.status === 401) {
                        await this.$router.push('/');
                    }
                }
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        }
    }
</script>
